import { render } from "./CheckRiddor.vue?vue&type=template&id=5bb959bb"
import script from "./CheckRiddor.vue?vue&type=script&lang=js"
export * from "./CheckRiddor.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__